import React, { useEffect, useState } from "react";
import { FormControl, MenuItem } from "@material-ui/core";
import { SelectValidator } from 'react-material-ui-form-validator';
import { fetchConToken } from "../../helpers/fetch";

export const CboTipoFeriados = (props) => {
  const [listaNac, setListaNac] = useState([]);

  useEffect(() => {
    const traerDatos = async () => {
      const response = await fetchConToken(`TipoFeriados`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (lista) {
          let listaFromApi = lista.map((item) => {
            return {
              value: item.idTipoFeriado,
              display: item.descripcionFeriado,
            };
          });
          setListaNac(listaFromApi);
        }
      }
    };
    traerDatos();
  }, []);

  return (
    <>
        <FormControl
          margin="normal"
          fullWidth={true}
        >
        <SelectValidator
            onChange={(e) => {
            props.manejadorInputChange(e);
            }}
            label="Tipo"
            name={props.name}
            value={props.valor}
            fullWidth={true}
            disabled={props.disabledForm}
            validators={['required']}
            errorMessages={['Seleccione una opción']}
        >
            <MenuItem value={null}>
            <em>Seleccione</em>
            </MenuItem>
            {listaNac.map((nac) => (
            <MenuItem key={nac.value} value={nac.value}>
                {nac.display}
            </MenuItem>
            ))}
        </SelectValidator>
        </FormControl>
    </>
  );
};
